// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__pOHog","container":"Footer_container__fpzdK","content":"Footer_content__AFBB9","section":"Footer_section__r1wVt","copyright":"Footer_copyright__wf17-"};